<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div>
        <v-icon>mdi-car</v-icon><span class="headerTitle">{{ labels.motorTitle }}</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.tarf }}</v-subheader>
                <span class="queryValue" v-if="mainForm.tarf">{{ mainForm.tarf }} - {{ mainForm.tarfDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.cvrType }}</v-subheader>
                <span class="queryValue" v-if="mainForm.cvrType">{{ mainForm.cvrType }} - {{ mainForm.cvrTypeDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.vehRegNo }}</v-subheader>
                <span class="queryValue" v-if="mainForm.vehRegNo">{{ mainForm.vehRegNo }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.cocNo }}</v-subheader>
                <span class="queryValue" v-if="mainForm.cocNo">{{ mainForm.cocNo }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md8 xs12>
                <v-subheader class="queryLabel">{{ labels.certRef }}</v-subheader>
                <span class="queryValue" v-if="mainForm.certRef">{{ mainForm.certRef }}</span>
                <span class="queryValue" v-else>-</span>
                <v-textarea v-model="mainForm.certRefDesc" :rows="4" readonly></v-textarea>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.trailerRegNo }}</v-subheader>
                <span class="queryValue" v-if="mainForm.trailerRegNo">{{ mainForm.trailerRegNo }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.engNo }}</v-subheader>
                <span class="queryValue" v-if="mainForm.engNo">{{ mainForm.engNo }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.chasNo }}</v-subheader>
                <span class="queryValue" v-if="mainForm.chasNo">{{ mainForm.chasNo }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.yrManuf }}</v-subheader>
                <span class="queryValue" v-if="mainForm.yrManuf">{{ mainForm.yrManuf }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.vehMakeModel }}</v-subheader>
                <span class="queryValue" v-if="mainForm.vehMake || mainForm.modelNo"
                  >{{ mainForm.vehMake }} / {{ mainForm.modelNo }} - {{ mainForm.modelDesc }}</span
                >
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.colour }}</v-subheader>
                <span class="queryValue" v-if="mainForm.colour">{{ mainForm.colour }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.regMthYr }}</v-subheader>
                <span class="queryValue" v-if="mainForm.regMth || mainForm.regYr">{{ mainForm.regMth }} / {{ mainForm.regYr }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.vehBody }}</v-subheader>
                <span class="queryValue" v-if="mainForm.vehBody">{{ mainForm.vehBodyWithDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.engCcTonnage }}</v-subheader>
                <span class="queryValue" v-if="mainForm.engCc || mainForm.tonnage">{{ mainForm.engCc }} / {{ mainForm.tonnage }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.maxLaden }}</v-subheader>
                <span class="queryValue" v-if="mainForm.maxLaden">{{ mainForm.maxLaden }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.unLaden }}</v-subheader>
                <span class="queryValue" v-if="mainForm.unLaden">{{ mainForm.unLaden }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.noSeats }}</v-subheader>
                <span class="queryValue" v-if="mainForm.noSeats">{{ mainForm.noSeats }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.mileage }}</v-subheader>
                <span class="queryValue" v-if="mainForm.mileage">{{ formatMileage(mainForm.mileage) }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.vehGrp }}</v-subheader>
                <span class="queryValue" v-if="mainForm.vehGrp">{{ mainForm.vehGrp }} - {{ mainForm.vehGrpDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.vehUse }}</v-subheader>
                <span class="queryValue" v-if="mainForm.vehUse">{{ mainForm.vehUse }} - {{ mainForm.vehUseDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.ownName }}</v-subheader>
                <span class="queryValue" v-if="mainForm.ownName">{{ mainForm.ownName }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.vehOwnIcnoId }}</v-subheader>
                <span class="queryValue" v-if="mainForm.vehOwnIcno || mainForm.vehOwnId">{{ mainForm.vehOwnIcno || mainForm.vehOwnId }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.vehPurPrice }}</v-subheader>
                <span class="queryValue" v-if="mainForm.vehPurPrice">{{ mainForm.vehPurPrice }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.hpOwn }}</v-subheader>
                <span class="queryValue" v-if="mainForm.hpOwn">{{ mainForm.hpOwn }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.ncbYrPct }}</v-subheader>
                <span class="queryValue" v-if="mainForm.ncbYr">{{ mainForm.ncbYr }} / {{ mainForm.ncbPct }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-checkbox v-model="mainForm.retnNcd" :label="labels.retnNcd" readonly hide-details class="ma-0 pa-0"></v-checkbox>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.logBook }}</v-subheader>
                <span class="queryValue" v-if="mainForm.logBook">{{ mainForm.logBook }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.ltaTranDate }}</v-subheader>
                <span class="queryValue" v-if="mainForm.ltaTranDate">{{ formatDate(mainForm.ltaTranDate) }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex xs12>
                <v-data-table :headers="drivers.headers" :items="drivers.list" class="elevation-1" :loading="drivers.loading">
                  <template v-slot:item="row">
                    <tr>
                      <td>{{ row.item.seqNo }}</td>
                      <td>{{ row.item.drvName }}</td>
                      <td>{{ row.item.drvYob }}</td>
                      <td>{{ row.item.drvExp }}</td>
                      <td>{{ row.item.drvDip }}</td>
                      <td>{{ row.item.drvMstat }}</td>
                      <td>{{ row.item.drvGender }}</td>
                      <td>{{ row.item.drvOccp }}</td>
                      <td style="text-align: center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="primary" text @click.prevent="doSelectDriver(row.item)">
                              <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ labels.query }}</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.drvName }}</v-subheader>
                <span class="queryValue" v-if="driverForm.drvName">{{ driverForm.drvName }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.drvDob }}</v-subheader>
                <!-- <span class="queryValue" v-if="driverForm.drvDob || driverForm.drvYob">{{driverForm.drvDob ? formatDate(driverForm.drvDob) : '-'}} / {{driverForm.drvYob}}</span> -->
                <span class="queryValue" v-if="driverForm.drvYob">{{ driverForm.drvYob }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <!-- <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{labels.drvIcno}}</v-subheader>
                <span class="queryValue" v-if="driverForm.drvIcno">{{driverForm.drvIcno}}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex> -->
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.drvGender }}</v-subheader>
                <span class="queryValue" v-if="driverForm.drvGender">{{ formatGender(driverForm.drvGender) }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.drvExp }}</v-subheader>
                <span class="queryValue" v-if="driverForm.drvExp">{{ driverForm.drvExp }}</span>
                <span class="queryValue" v-else>0</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.drvDip }}</v-subheader>
                <span class="queryValue" v-if="driverForm.drvDip">{{ driverForm.drvDip }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.drvOccp }}</v-subheader>
                <span class="queryValue" v-if="driverForm.drvOccp">{{ driverForm.drvOccp }} - {{ formatOccp(driverForm.drvOccp) }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.drvMstat }}</v-subheader>
                <span class="queryValue" v-if="driverForm.drvMstat">{{ formatMaritalStatus(driverForm.drvMstat) }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'
import { gender, maritalStatus } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        motorTitle: 'Motor Risk Details',
        tarf: 'Tariff',
        cvrType: 'Cover Type',
        vehRegNo: 'Vehicle Registration No.',
        cocNo: 'Certificate of Insurance No.',
        certRef: 'Certificate of Insurance Reference',
        trailerRegNo: 'Trailer Registration No.',
        engNo: 'Engine No.',
        yrManuf: 'Year of Manufacture',
        chasNo: 'Chassis No.',
        logBook: 'Log Book No.',
        vehMakeModel: 'Make / Model',
        colour: 'Colour',
        regMthYr: 'Registration Month / Year',
        vehBody: 'Body Type',
        engCcTonnage: 'Engine CC / Tonnage',
        maxLaden: 'Maximum Laden Weight',
        unLaden: 'Unladen Weight',
        noSeats: 'No. of Seats',
        mileage: 'Mileage',
        vehGrp: 'Vehicle Group',
        vehUse: 'Vehicle Usage',
        ownName: 'Owner Name',
        vehOwnIcnoId: 'Owner NRIC No. / Id',
        vehPurPrice: 'New Car Purchase Price',
        hpOwn: 'Hire Purchase Owner',
        ncbYrPct: 'NCB Years / %',
        retnNcd: 'Retain NCB on Renewal',
        ltaTranDate: 'LTA Transmission Date',
        upldDate: 'LTA Update Date',
        query: 'Query',
        drvName: 'Driver Name',
        drvDob: 'Year of Birth',
        drvIcno: 'Driver NRIC',
        drvGender: 'Gender',
        drvExp: 'Years of Experience',
        drvDip: 'DIP',
        drvOccp: 'Occupation',
        drvMstat: 'Marital Status'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        tarf: undefined,
        tarfDesc: undefined,
        cvrType: undefined,
        cvrTypeDesc: undefined,
        vehRegNo: undefined,
        cocNo: undefined,
        certRef: undefined,
        certRefDesc: undefined,
        trailerRegNo: undefined,
        logBook: undefined,
        engNo: undefined,
        yrManuf: undefined,
        chasNo: undefined,
        regMth: undefined,
        regYr: undefined,
        vehMake: undefined,
        modelNo: undefined,
        modelDesc: undefined,
        vehBody: undefined,
        vehBodyDesc: undefined,
        vehBodyWithDesc: undefined,
        engCc: undefined,
        tonnage: undefined,
        maxLaden: undefined,
        noSeats: undefined,
        colour: undefined,
        vehGrp: undefined,
        vehGrpDesc: undefined,
        unLaden: undefined,
        vehUse: undefined,
        vehUseDesc: undefined,
        ownName: undefined,
        mileage: undefined,
        ncbYr: undefined,
        ncbPct: undefined,
        vehOwnIcno: undefined,
        vehOwnId: undefined,
        vehPurPrice: undefined,
        retnNcd: undefined,
        hpOwn: undefined,
        hpOwnDesc: undefined,
        ltaTranDate: undefined,
        upldDate: undefined
      },
      drivers: {
        headers: [
          { text: 'Seq No.', align: 'left', value: 'seqNo' },
          { text: 'Driver Name', value: 'drvName' },
          { text: 'Driver YOB', value: 'drvYob' },
          { text: 'Experience', value: 'drvExp' },
          { text: 'DIP', value: 'drvDip' },
          { text: 'Marital Status', value: 'drvMstat' },
          { text: 'Gender', value: 'drvGender' },
          { text: 'Occupation', value: 'drvOccp' },
          { text: 'Actions', value: 'action', align: 'center' }
        ],
        list: [],
        loading: false
      },
      driverForm: {
        seqNo: undefined,
        drvName: undefined,
        drvDob: undefined,
        drvYob: undefined,
        drvIcno: undefined,
        drvExp: undefined,
        drvDip: undefined,
        drvMstat: undefined,
        drvGender: undefined,
        drvLicType: undefined,
        drvOldIc: undefined,
        drvPostCode: undefined,
        drvOccp: undefined,
        drvFirstYr: undefined
      }
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maritalStatusList() {
      let result = []
      Object.keys(maritalStatus).forEach(function (key) {
        const status = maritalStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  methods: {
    formatDate(xDate) {
      if (xDate === null || xDate === undefined) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatMileage(value) {
      let val = value / 1
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    doInit() {
      this.getPolMotorRisk()
    },
    async getPolMotorRisk() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.polMotorRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polMtrRisk) {
            this.mainForm.tarf = result.data.polMtrRisk.data.tarf
            this.mainForm.tarfDesc = result.data.polMtrRisk.data.tarfDesc
            this.mainForm.cvrType = result.data.polMtrRisk.data.cvrType
            this.mainForm.cvrTypeDesc = result.data.polMtrRisk.data.cvrTypeDesc
            this.mainForm.vehRegNo = result.data.polMtrRisk.data.vehRegNo
            this.mainForm.cocNo = result.data.polMtrRisk.data.cocNo
            this.mainForm.certRef = result.data.polMtrRisk.data.certRef
            this.mainForm.certRefDesc = result.data.polMtrRisk.data.certRefDesc
            this.mainForm.trailerRegNo = result.data.polMtrRisk.data.trailerRegNo
            this.mainForm.logBook = result.data.polMtrRisk.data.logBook
            this.mainForm.engNo = result.data.polMtrRisk.data.engNo
            this.mainForm.yrManuf = result.data.polMtrRisk.data.yrManuf
            this.mainForm.chasNo = result.data.polMtrRisk.data.chasNo
            this.mainForm.regMth = result.data.polMtrRisk.data.regMth
            this.mainForm.regYr = result.data.polMtrRisk.data.regYr
            this.mainForm.vehMake = result.data.polMtrRisk.data.vehMake
            this.mainForm.modelNo = result.data.polMtrRisk.data.modelNo
            this.mainForm.modelDesc = result.data.polMtrRisk.data.modelDesc
            this.mainForm.vehBody = result.data.polMtrRisk.data.vehBody
            this.mainForm.vehBodyDesc = result.data.polMtrRisk.data.vehBodyDesc
            this.mainForm.vehBodyWithDesc = this.mainForm.vehBody + ' - ' + this.mainForm.vehBodyDesc
            this.mainForm.engCc = result.data.polMtrRisk.data.engCc
            this.mainForm.tonnage = formatPrice(result.data.polMtrRisk.data.tonnage)
            this.mainForm.maxLaden = formatPrice(result.data.polMtrRisk.data.maxLaden)
            this.mainForm.noSeats = result.data.polMtrRisk.data.noSeats
            this.mainForm.colour = result.data.polMtrRisk.data.colour
            this.mainForm.vehGrp = result.data.polMtrRisk.data.vehGrp
            this.mainForm.vehGrpDesc = result.data.polMtrRisk.data.vehGrpDesc
            this.mainForm.unLaden = formatPrice(result.data.polMtrRisk.data.unLaden)
            this.mainForm.vehUse = result.data.polMtrRisk.data.vehUse
            this.mainForm.vehUseDesc = result.data.polMtrRisk.data.vehUseDesc
            this.mainForm.ownName = result.data.polMtrRisk.data.ownName
            this.mainForm.mileage = result.data.polMtrRisk.data.mileage
            this.mainForm.ncbYr = result.data.polMtrRisk.data.ncbYr
            this.mainForm.ncbPct = result.data.polMtrRisk.data.ncbPct
            this.mainForm.vehOwnIcno = result.data.polMtrRisk.data.vehOwnIcno
            this.mainForm.vehOwnId = result.data.polMtrRisk.data.vehOwnId
            // this.mainForm.vehPurPrice = result.data.polMtrRisk.data. Missing field
            this.mainForm.retnNcd = result.data.polMtrRisk.data.retnNcd
            this.mainForm.hpOwn = result.data.polMtrRisk.data.hpOwn
            this.mainForm.hpOwnDesc = result.data.polMtrRisk.data.hpOwnDesc
            this.mainForm.ltaTranDate = result.data.polMtrRisk.data.ltaTranDate
            this.mainForm.upldDate = result.data.polMtrRisk.data.upldDate
          }

          if (result.data.polMtrDrvList) {
            this.displayDrivers(result.data.polMtrDrvList).then(() => {
              if (this.drivers.list.length > 0) {
                this.setDriver(this.drivers.list[0])
              }
            })
          }

          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async displayDrivers(polMtrDrvList) {
      if (polMtrDrvList) {
        this.drivers.list = []
        const { data } = polMtrDrvList
        data.map((driver) => {
          const convertDriver = {
            seqNo: driver.seqNo.toString().padStart(3, '0'),
            drvName: driver.drvName,
            drvDob: driver.drvDob,
            drvDobFormat: formatDisplayDate(driver.drvDob),
            drvYob: driver.drvYob,
            drvIcno: driver.drvIcno,
            drvExp: driver.drvExp,
            drvDip: driver.drvDip,
            drvMstat: driver.drvMstat,
            drvGender: driver.drvGender,
            drvLicType: driver.drvLicType,
            drvOldIc: driver.drvOldIc,
            drvPostCode: driver.drvPostCode,
            drvOccp: driver.drvOccp,
            drvFirstYr: driver.drvFirstYr,
            newDrv: driver.newDrv
          }
          this.drivers.list.push(convertDriver)
        })
      } else {
        this.drivers.list = []
      }
    },
    doSelectDriver(data) {
      this.setDriver(data)
    },
    setDriver(data) {
      if (data) {
        this.driverForm.seqNo = data.seqNo
        this.driverForm.drvName = data.drvName
        this.driverForm.drvDob = data.drvDob
        this.driverForm.drvYob = data.drvYob
        this.driverForm.drvIcno = data.drvIcno
        this.driverForm.drvExp = data.drvExp
        this.driverForm.drvDip = data.drvDip
        this.driverForm.drvMstat = data.drvMstat
        this.driverForm.drvGender = data.drvGender
        this.driverForm.drvLicType = data.drvLicType
        this.driverForm.drvOldIc = data.drvOldIc
        this.driverForm.drvPostCode = data.drvPostCode
        this.driverForm.drvOccp = data.drvOccp
        this.driverForm.drvFirstYr = data.drvFirstYr
      }
    },
    formatGender(data) {
      var gender = this.genderList.filter((gender) => {
        return gender.value === data
      })

      if (gender.length > 0) {
        return gender[0].label
      } else {
        return data
      }
    },
    formatMaritalStatus(data) {
      var mStat = this.maritalStatusList.filter((mStat) => {
        return mStat.value === data
      })

      if (mStat.length > 0) {
        return mStat[0].label
      } else {
        return data
      }
    },
    formatOccp(data) {
      if (data === 'I') {
        return 'INDOOR'
      } else if (data === 'O') {
        return 'OUTDOOR'
      } else {
        return ''
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyQuerySettings.init !== 1) {
      this.$store.dispatch('policyQueryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
